angular.module('myApp')
    .service('UserInitializationService', function($http, $rootScope, $q) {
        this.pending = false;

        this.initialize = function() {
            if (this.initializedPromise) {
                // Вернуть существующий promise, если он уже инициализирован
                return this.initializedPromise;
            }
            this.pending = true;
            loadOverlay.open();
            const csrftoken = getCookie('csrftoken');
            const authRequest = $http.get('/api/v4/auth/current/', { withCredentials: true });
            const verifyRequest = $http.post('/auth/api/v1/auth/verify/', undefined, {
                headers: { 'X-CSRFToken': csrftoken },
                withCredentials: true,
            });
            const tabsAbbreviated = $http.get('/api/v4/tabs_abbreviated/', { withCredentials: true });

            this.initializedPromise = $q.all([authRequest, verifyRequest, tabsAbbreviated])
                .then(function(responses) {
                    return legacyCode(responses[0].data, responses[1]).then(function() {
                        $rootScope.userInfo = responses[0].data;
                        $rootScope.userPermissions = responses[1].data.permissions;
                        // схожая проверка присутствовала в tornado (в Provider.get_allowed())
                        const extraPermissionsCondition = $rootScope.userInfo._extra.is_master_super || (
                            !$rootScope.userInfo._extra.is_super &&
                            $rootScope.userInfo._extra.business_types.indexOf('sales') !== -1
                        );

                        if (extraPermissionsCondition) {
                            $rootScope.userPermissions['worker_info'] = {title: 'Общие сведения', crud: 'CRUD'};
                            $rootScope.userPermissions['employers_list'] = {title: 'Список сотрудников', crud: 'CRUD'};
                            $rootScope.userPermissions['hr'] = {title: 'Сотрудники', crud: 'CRUD'};
                        }

                        $rootScope.tabsExtraData = responses[2].data;
                        $rootScope.$broadcast('userInfoInitialized');
                    });
                })
                .catch(function(error) {
                    console.error('Error during initialization:', error);
                    throw error;
                })
                .finally(function() {
                    this.pending = false;
                    $rootScope.$broadcast('forceUserUpdate');
                    loadOverlay.close();
                }.bind(this));

            return this.initializedPromise;
        };

        // сюда вынесен весь legacy код (из обработчика response api/v2/auth/current) без изменений
        function legacyCode(userData, permission_resp) {
            // legacy код 2016-2022 г.
            if (userData._extra && userData._extra.business_types) {
                userData._extra.has_cc = userData._extra.business_types.indexOf('cс') !== -1;
            }

            $rootScope.getBalanceData = function() {
                return $http.get('/api/v4/accounting/get_contracts_balances/')
                    .then(function(response) {
                        $rootScope.balanceData = response.data.results;
                        $rootScope.balanceDataValue = $rootScope.balanceData.length > 0;
                        $rootScope.balanceData.forEach(function(item) {
                            item.balance = -item.balance;
                        });

                        $rootScope.balanceTotal = $rootScope.balanceData.reduce(function(p, c) {
                            return p + c.balance;
                        }, 0);

                        if ($rootScope.balanceTotal < 0) {
                            const contracts = response.data.results || [];
                            if (contracts.length) {
                                let currentContract = contracts[0];
                                contracts.forEach(function(contract) {
                                    if (contract.balance < currentContract.balance) {
                                        currentContract = contract;
                                    }
                                });
                                const daysLeft = (currentContract.provider_days_to_debtor - moment().diff(currentContract.debtor_date, 'days')) || 0;
                                $rootScope.providerDebtorData = {
                                    showNotify: currentContract.debtor_date && currentContract.disable_when_debtor,
                                    daysLeft: daysLeft > 0 ? daysLeft : 0,
                                };
                            }
                            $('#balanceColor').css('color', '#DD1144');
                        } else {
                            $('#balanceColor').css('color', '#8cbb52');
                        }
                    });
            };

            /*Жуткий костыль, временно, пока статусы не будут приходить правильные TODO - заменить на $rootScope.getBalanceData */
            $rootScope.getBalanceDataTempraryFunction = function(index, type) {
                if (type === 'act') {
                    $rootScope.balanceData[index].reconciliation_act.state = "wip";
                } else {
                    $rootScope.balanceData[index].archive_documents.state = "wip";
                }
            };

            const shouldFetchBalanceData = (
                userData._extra.is_master_super
                || permission_resp?.data?.permissions?.house_accruals_factors?.crud.includes('R')
            );

            if (shouldFetchBalanceData) {
                return $rootScope.getBalanceData().then(function() {
                    setProviderAndMomentOffset();
                });
            } else {
                return $q.when();
            }

            function setProviderAndMomentOffset() {
                $rootScope.currentProvider = userData._extra.type === 'Provider'
                    ? userData.id
                    : (userData.provider ? userData.provider.id : '');

                function setMomentOffset(serverTime) {
                    const offset = moment(serverTime).diff(Date.now());
                    moment.now = function() {
                        return offset + Date.now();
                    };
                }
                setMomentOffset(userData._extra.now);

                $?.material?.init();
            }
        }
    });